import {Component, OnInit} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {moduloAutoconsumo} from "../../diccionarios/autoconsumoModulo.js";
import {DatosMaestrosService} from "../../../../services/datos-maestros.service";
import {forkJoin} from "rxjs";
import {AutoconsumoCreacionMantenedorService} from "../../services/autoconsumo-creacion-mantenedor.service";
import {Client} from "../../../portfolio/interfaces/client.interface";


@Component({
  selector: 'app-creacion-mantenedor',
  templateUrl: './creacion-mantenedor.component.html',
  styleUrls: ['./creacion-mantenedor.component.css']
})
export class CreacionMantenedorComponent implements OnInit {
  mostrarFormulario: boolean = false;
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  cmbOrganizacionVenta: any[];
  cmbCanalVenta: any[];
  cmbSectorVenta: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  obligatorylocality: boolean = false;
  today: any;


  constructor(
    private fb: FormBuilder,
    private _autoconsumoCreacionMantenedorService: AutoconsumoCreacionMantenedorService,
    private _datosMaestrosService: DatosMaestrosService,
    private _util: UtilsService,
  ) {
    this.diccionarioModulo = moduloAutoconsumo;
  }

  ngOnInit(): void {
    this.DAT_BTNS = moduloAutoconsumo.button.buttonsNombre;
    this.DAT_TITULOS = moduloAutoconsumo.titulos.autoconsumoCreacionMantenedor;
    this.DAT_BTNCSS = moduloAutoconsumo.button.buttonsCss;
    this.DAT_MSG = moduloAutoconsumo.mensajes;
    this.titulo = this.DAT_TITULOS.titulo;
    this.formulario = this.fb.group({
      idParametro: [''],
      idOrgaVenta: ['', [Validators.required]],
      idCanalVenta: ['', Validators.required],
      idSectorVenta: ['', [Validators.required,]],
      idCliente: ['', [Validators.required,]],
      nombreCliente: ['', [Validators.required,]]
    });
    this.getFormInfo();
    //this.getAllFeriados();
  }


  /*  getAllFeriados() {
      this.loading = true;
      this._parametrizacionFeriado.getAll().subscribe((res: any) => {
        this.rowData = res;
        this.loading = false;
      }, () => {
        this.loading = false;
        this.rowData = [];
      });
    }*/

  getFormInfo() {
    this.loading = true;
    const _getAllOrganizacionVenta = this._datosMaestrosService.getAllOrganizacionVenta();
    const _getAllCanalVenta = this._datosMaestrosService.getAllCanalVenta();
    const _getAllSectorVenta = this._datosMaestrosService.getAllSectorVenta();
    const _getAllAutoconsumoMantenedor = this._autoconsumoCreacionMantenedorService.getAll();


    forkJoin([_getAllOrganizacionVenta, _getAllCanalVenta, _getAllSectorVenta, _getAllAutoconsumoMantenedor]).subscribe((res: any) => {
      res[0].map(organizacionVenta => {
        organizacionVenta.id = organizacionVenta.idOrgaVenta;
        organizacionVenta.descripcion = organizacionVenta.idOrgaVenta + ' | ' + organizacionVenta.dscaOrgaVenta;
      });
      res[1].map(canalVenta => {
        canalVenta.id = canalVenta.idCanalVenta;
        canalVenta.descripcion = canalVenta.idCanalVenta + ' | ' + canalVenta.dscaCanalVenta;
      });
      res[2].map(sectorVenta => {
        sectorVenta.id = sectorVenta.idSectorVenta;
        sectorVenta.descripcion = sectorVenta.idSectorVenta + ' | ' + sectorVenta.dscaSectorVenta;
      });

      this.cmbOrganizacionVenta = res[0].filter((word) => word.id == '1001');
      /*if (this.cmbOrganizacionVenta.find(x => ( x.id == '0001' ))) {
        this.cmbOrganizacionVenta.splice(res[0].findIndex( x => ( x == '0001' )), 1);
     }else if(this.cmbOrganizacionVenta.find(x => ( x.id == '0003' ))){
        this.cmbOrganizacionVenta.splice(res[0].findIndex( x => ( x == '0003' )), 1);
     }*/
      this.cmbCanalVenta = res[1];
      this.cmbSectorVenta = res[2];
      //console.log(res[3]);
      if (res[3] && res[3].respuesta && res[3].respuesta.length > 0) {
        this.formatData(res[3].respuesta[0]);
      }
      this.loading = false;
    }, () => {
      this.loading = false;
      this.cmbOrganizacionVenta = [];
      this.cmbCanalVenta = [];
      this.cmbSectorVenta = [];
    });
  }

  formatData(data) {
    this.formulario.get('idParametro').setValue(data.idParametro);
    this.formulario.get('idOrgaVenta').setValue(data.idOrgaVenta);
    this.formulario.get('idCanalVenta').setValue(data.idCanalVenta);
    this.formulario.get('idSectorVenta').setValue(data.idSectorVenta);
    this.formulario.get('idCliente').setValue(data.idCliente);
    this.formulario.get('nombreCliente').setValue(data.idCliente + ' | ' + data.cliente.nombreCliente1);
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
      } else {
        this.guardarMantenedor();
      }
    } else {
      this.titulo = this.DAT_TITULOS.tituloCardListar;
    }
  }


  guardarMantenedor() {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: ``,
        action: this.DAT_BTNS.guardar,
        funcion: this._autoconsumoCreacionMantenedorService.creacionMantenedor(this.formatCreacionMantenedor(this.formulario.value)),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getFormInfo();
      //this.getAllFeriados();
      //this.regresar();
    });
  }

  formatCreacionMantenedor(data) {

    return {
      idOrgaVenta: data.idOrgaVenta,
      idCanalVenta: data.idCanalVenta,
      idSectorVenta: data.idSectorVenta,
      idCliente: data.idCliente,
    }
  }

  regresar() {
    this.formulario.reset();
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }


  clienteSelected(cliente: Client) {
    //console.log(cliente);
    this.formulario.get('idCliente').setValue(cliente.idCliente);
    this.formulario.get('nombreCliente').setValue(cliente.idCliente + ' | ' + cliente.nombreCliente1);
  }

  formatForm(data) {
    //console.log(data);
    if (data.idOrgaVenta) {
      this.formulario.get('idOrgaVenta').setValue(data.idOrgaVenta);
    }
    if (data.idCanalVenta) {
      this.formulario.get('idCanalVenta').setValue(data.idCanalVenta);
    }
    if (data.idSectorVenta) {
      this.formulario.get('idSectorVenta').setValue(data.idSectorVenta);
    }
    if (data.idParametro) {
      this.formulario.get('idParametro').setValue(data.idParametro);
    }
  }

}
